import { a as SECRET, S as SERVICE_ID, A as API_CLIENT_ID, K as KEY } from "../../../../chunks/private.js";
import { redirect } from "@sveltejs/kit";
import { createHmac } from "node:crypto";
import { p as prisma } from "../../../../chunks/prisma.js";
import { g as getActivePromotions, b as buildPromotionIndex, a as selectBestPromotionIndexed } from "../../../../chunks/promotionPricing.js";
const load = (async ({ locals: { user }, url: { origin }, depends }) => {
  if (!user) redirect(302, "/login");
  depends("update:paymentDetails");
  try {
    const cart = await prisma.cart.findUnique({
      where: {
        userId: user.id
      },
      include: {
        // Reason: We need product categories to evaluate category-based promotions on checkout
        CartItem: { include: { product: { include: { categories: { select: { id: true } } } } } },
        user: { select: { name: true, email: true, phoneNumber: true, idNumber: true } }
      }
    });
    if (!cart) {
      console.error("Cart not found");
      return { error: "Cart not found" };
    }
    const convenienceFee = await prisma.convenienceFee.findFirst() || { amount: 0 };
    const productIds = cart.CartItem.map((ci) => ci.product.id);
    const categoryIds = Array.from(
      new Set(
        cart.CartItem.flatMap((ci) => (ci.product.categories || []).map((c) => c.id))
      )
    );
    const activePromos = await getActivePromotions(/* @__PURE__ */ new Date(), { productIds, categoryIds });
    const promoIndex = buildPromotionIndex(activePromos);
    const discountedSubtotal = cart.CartItem.reduce((total, item) => {
      const base = item.product.price;
      const cats = (item.product.categories || []).map((c) => c.id);
      const applied = selectBestPromotionIndexed(base, item.product.id, cats, promoIndex);
      const unit = applied?.finalUnitPrice ?? base;
      return total + unit * item.quantity;
    }, 0);
    const totalPrice = Number(discountedSubtotal.toFixed(2));
    const billRefNumber = `ORDER-${Date.now()}`;
    await prisma.cart.update({
      where: { userId: user.id },
      data: {
        paymentReference: billRefNumber,
        status: "PENDING_PAYMENT"
      }
    });
    const paymentDetails = {
      apiClientID: API_CLIENT_ID,
      // Your Pesaflow API Client ID
      amountExpected: Number((totalPrice + convenienceFee.amount).toFixed(2)),
      serviceID: SERVICE_ID,
      clientIDNumber: cart.user.idNumber || "0",
      currency: "KES",
      billRefNumber,
      billDesc: "Product Purchase",
      clientName: cart.user.name || cart.user.email,
      secret: SECRET
    };
    const dataString = [
      paymentDetails.apiClientID,
      paymentDetails.amountExpected,
      paymentDetails.serviceID,
      paymentDetails.clientIDNumber,
      paymentDetails.currency,
      paymentDetails.billRefNumber,
      paymentDetails.billDesc,
      paymentDetails.clientName,
      paymentDetails.secret
    ].join("");
    const secureHash = generateSecureHash(dataString, KEY);
    return {
      paymentDetails: {
        ...paymentDetails,
        secureHash,
        callBackURLOnSuccess: `${origin}/checkout`,
        callBackURLOnFail: `${origin}/checkout`,
        notificationURL: `${origin}/api/order/notification_url`,
        clientEmail: cart.user.email,
        clientMSISDN: cart.user.phoneNumber || "0700000000",
        pictureURL: `${origin}/kLawLogo.png`
      },
      convenienceFee
    };
  } catch (e) {
    console.error(e);
    return { error: "Internal Error loading checkout page" };
  }
});
function generateSecureHash(dataString, secretKey) {
  const hmac = createHmac("sha256", secretKey);
  hmac.update(dataString);
  return hmac.digest("base64");
}
export {
  load
};
